import { InputTheme } from "@acin.reactjs/acin-ui/input";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";
import { AppMediaQueries } from "./BreakpointsTheme";

const inputTheme = (theme: DefaultTheme): ComponentCSSStyle<InputTheme> => ({
  variants: {
    publicContestSelector: {
      container: {
        borderColor: theme.palette.greys[200],
        flexGrow: 1,
        borderRadius: "99px",
        margin: 0,

        [AppMediaQueries.maxMobile]: {
          borderRadius: "4px",
        },
      },
      input: {
        fontSize: "14px",
      },
    },
    publicEmail: {
      container: {
        flexGrow: 1,
      },

      focused: {
        container: {
          boxShadow: `0px 0px 0px 2px ${theme.palette.secondary[100]}`,
        },
      },
    },
    publicEmailWithoutError: {
      container: {
        flexGrow: 1,
      },

      focused: {
        container: {
          boxShadow: `0px 0px 0px 2px ${theme.palette.secondary[100]}`,
        },
      },
      formHelperText: {
        container: {
          display: "none",
        },
      },
    },
    discountCode: {
      container: {
        minWidth: "200px",
      },
      formHelperText: {
        container: {
          marginBottom: "16px",
        },
      },
    },
    colorWrapper: {
      formLabel: { asterisk: { readOnly: { root: { display: "none" } } } },
    },
  },
  formLabel: { asterisk: { readOnly: { root: { display: "none" } } } },
});

export default inputTheme;
